import { withPropsOnChange } from 'recompose';
import { get } from 'lodash';

const withDebug = (watchThis) =>
  withPropsOnChange([watchThis],(props) => {
    console.log(get(props,watchThis)); 
    return {props}
  });

export default withDebug;



// WEBPACK FOOTER //
// ./src/components/common/withDebug.js